/**
 * Load Stripe.js only when needed (e.g. payment modals, checkout).
 * Avoids blocking initial page load on pages that don't use Stripe (e.g. invoices).
 */
const STRIPE_SCRIPT_URL = 'https://js.stripe.com/v3/';
/** @type {Promise<((publishableKey: string) => unknown) | null> | null} */
let loadPromise = null;

/**
 * @returns {Promise<((publishableKey: string) => unknown) | null>}
 */
export function loadStripeScript() {
  if (typeof window === 'undefined') return Promise.resolve(null);
  if (typeof window.Stripe === 'function') {
    return Promise.resolve(window.Stripe);
  }
  if (loadPromise) return loadPromise;
  loadPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = STRIPE_SCRIPT_URL;
    script.async = true;
    script.onload = () => {
      if (typeof window.Stripe === 'function') {
        resolve(window.Stripe);
      } else {
        loadPromise = null;
        reject(new Error('Stripe not available after script load'));
      }
    };
    script.onerror = () => {
      loadPromise = null;
      reject(new Error('Failed to load Stripe'));
    };
    document.head.appendChild(script);
  });
  return loadPromise;
}
